

import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/User/UserContext";
import { useTheme } from "../hooks/useTheme";
import { Crear } from "../components/Botones/Crear";
import { getDataObtenerUno } from "../api/common";
import { useEffect } from "react";
import { Firma } from "../components/Ot/firma";
import { Alertassw } from "../components/Alertas/Alertassw";
import EngineSettings from "../components/EngineSettings/EngineSettings";
import { ConsultNot } from "../components/NavBar/ConsultNot";
import { SearchBar } from "../components/NavBar/Buscador";
import { queryClient } from "../libs/queryClient";







export const Navegacion = () => {

    const navigate = useNavigate()
    
    const [estadofirma, setEstadofirma] = useState(false);
    const [recibido, setRecibido] = useState({});
    const { isOpenSide, setIsOpenSide, size } = useTheme()
    
    const { setUserData, userData } = useContext(UserContext);
    
    const logOut = () => {
        localStorage.clear()
        // Purgar cache de React Query para que el siguiente usuario no herede
        // datos cacheados del actual (mitiga S-MED-01).
        queryClient.clear()
        setUserData(null)
        navigate('/login')
    }
    
    useEffect(() => {
        async function consultarSing() {
            const signDb = await getDataObtenerUno("sign", {
                user: userData._id,
            });
            if (!signDb.data.data) {
                Alertassw('error', 'No tienes firma registrada, por favor dibuja tu firma para continuar')
                setEstadofirma(true)
            }
        }
        if (!userData) return
        consultarSing()
    }, [])

    return (
        <div>
            <header className={`header ${!userData ? 'header-no-logged' : 'header-logged'}`}
                style={{paddingLeft: isOpenSide && size.width >= 768 ? '220px' : size.width >= 768 ? '60px' : '0'}}
            >
                <div className="nav">
                    {userData && (
                        <div className="logo" onClick={() => setIsOpenSide(!isOpenSide)}>
                            <i className="bi bi-list" style={{fontSize: '30px'}}></i>
                        </div>
                    )}

                    {userData && (
                        <ul className="nav-menu nav-menu_visible">
                            {/* Buscador - visible en todas las pantallas */}
                            <SearchBar />

                            {/* Botón Crear - visible en todas las pantallas */}
                            <li className="crear">
                                <Crear />
                            </li>

                            {/* Elementos solo visibles en desktop (> 768px) */}
                            {size.width >= 768 && (
                                <>
                                    {userData?.role?.nombre !== 'Cliente' ? (
                                        <div className="userNavegacion">
                                            <li className="userAuth">{userData?.nombre + ' ' + userData?.apellido}</li>
                                            <li className="roleUser">{userData?.role.nombre}</li>
                                        </div>
                                    ) : (
                                        <div className="userNavegacion">
                                            <li className="userAuth">{userData?.nombre}</li>
                                            <li className="roleUser">{userData?.role.nombre}</li>
                                        </div>
                                    )}

                                    <div className="iconos">
                                        <ConsultNot />
                                    </div>

                                    <div className="iconos">
                                        <EngineSettings />
                                    </div>
                                </>
                            )}
                        </ul>
                    )}
                </div>
            </header>
        
            {estadofirma === true ? (
                <Firma
                    recibidoin={recibido}
                    setRecibidoin={setRecibido}
                    setEstadofirma={setEstadofirma}
                    estadofirma={estadofirma}
                    usersign={"entrega"}
                />
            ) : null}
        </div>
    )
}




